module.exports = __webpack_public_path__ + "img/fasttrack_mou.a433cd6f.png";